module.exports = __webpack_public_path__ + "static/img/shipinhuiyi2.fb4daa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/shipinhuiyi2.png
// module id = QMiJ
// module chunks = 24